// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.RoiList in roi/roiConfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.immutableCopyOf
import com.squareup.wire.`internal`.redactElements
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import okio.ByteString

/**
 * List of ROIa
 */
public class RoiList(
  rois: List<RoiConfiguration> = emptyList(),
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<RoiList, Nothing>(ADAPTER, unknownFields) {
  @field:WireField(
    tag = 1,
    adapter = "vreo.volt.protocol.RoiConfiguration#ADAPTER",
    label = WireField.Label.REPEATED,
    schemaIndex = 0,
  )
  public val rois: List<RoiConfiguration> = immutableCopyOf("rois", rois)

  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is RoiList) return false
    if (unknownFields != other.unknownFields) return false
    if (rois != other.rois) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + rois.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    if (rois.isNotEmpty()) result += """rois=$rois"""
    return result.joinToString(prefix = "RoiList{", separator = ", ", postfix = "}")
  }

  public fun copy(rois: List<RoiConfiguration> = this.rois, unknownFields: ByteString = this.unknownFields): RoiList = RoiList(rois, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<RoiList> = object : ProtoAdapter<RoiList>(
      FieldEncoding.LENGTH_DELIMITED, 
      RoiList::class, 
      "type.googleapis.com/vreo.volt.protocol.RoiList", 
      PROTO_3, 
      null, 
      "roi/roiConfig.proto"
    ) {
      override fun encodedSize(`value`: RoiList): Int {
        var size = value.unknownFields.size
        size += RoiConfiguration.ADAPTER.asRepeated().encodedSizeWithTag(1, value.rois)
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: RoiList) {
        RoiConfiguration.ADAPTER.asRepeated().encodeWithTag(writer, 1, value.rois)
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: RoiList) {
        writer.writeBytes(value.unknownFields)
        RoiConfiguration.ADAPTER.asRepeated().encodeWithTag(writer, 1, value.rois)
      }

      override fun decode(reader: ProtoReader): RoiList {
        val rois = mutableListOf<RoiConfiguration>()
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> rois.add(RoiConfiguration.ADAPTER.decode(reader))
            else -> reader.readUnknownField(tag)
          }
        }
        return RoiList(
          rois = rois,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: RoiList): RoiList = value.copy(
        rois = value.rois.redactElements(RoiConfiguration.ADAPTER),
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
